export default __webpack_public_path__ + "static/media/faqicon2.e58003a0.svg";